<template>
  <div
    id="app"
    v-loading="$store.state.api_loading"
    element-loading-background="rgba(0, 0, 0, 0.6)"
    @click="time_out"
  >
    <router-view></router-view>

    <!-- 自动退出登录 -->
    <el-dialog
      :visible.sync="auto_log_out_dlg"
      custom-class="auto_log_out_dlg_bgc"
      append-to-body
      center
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @open="open_time_60"
      @close="close_time_60"
      width="480px"
    >
      <div class="log_out1">
        <img src="./assets/img/warning_icon.png" alt="" />
      </div>
      <div class="log_out2">
        {{ $t("main.text257") }}
      </div>
      <div class="log_out3">
        {{ $t("main.text258") }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="cancel_btn" @click="log_out_btn">{{
          $t("main.text259")
        }}</el-button>
        <el-button type="primary" class="confirm_btn" @click="maintain_login">{{
          $t("main.text260")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { exitLogin, getUserInfo } from "@/api/api";

export default {
  data() {
    return {
      countDownNum: 60 * 15,
      timer: null,
      auto_log_out_dlg: false,

      // 弹框出现 1分钟 自动退出
      auto_Num: 60,
      auto_timer: null,
    };
  },
  created() {
    if (sessionStorage.getItem("token") && sessionStorage.getItem("userid")) {
      this.get_user_info();
    }
  },
  mounted() {
    let lan = localStorage.getItem("language");
    if (!lan) {
      localStorage.setItem("language", "en");
    }
    clearInterval(this.timer);
    setTimeout(() => {
      if (this.timer == null) {
        this.time_15();
      }
    }, 100);
  },
  watch: {
    $route() {
      if (this.timer == null) {
        this.time_15();
      }
    },
  },
  methods: {
    get_user_info() {
      getUserInfo().then((res) => {
        if (res.data.code == 200) {
          // kyc_status: KYC状态 0没有 1保存未提交 2 待审核   3一审通过  4审核通过  5审核失败
          // 4审核通过 路由才能跳转
          sessionStorage.setItem("project_name", res.data.data.project_name);
          sessionStorage.setItem("kyc_status", res.data.data.kyc_status);
        }
      });
    },
    time_out() {
      // console.log('click');
      this.countDownNum = 60 * 15;
      clearInterval(this.timer);
      this.time_15();
    },
    // 15分钟自动退出
    time_15() {
      // 已经登录
      if (
        sessionStorage.getItem("token") &&
        sessionStorage.getItem("userid") &&
        sessionStorage.getItem("username")
      ) {
        this.timer = setInterval(() => {
          this.countDownNum--;
          if (this.countDownNum <= 0) {
            clearInterval(this.timer);
            // 强制踢出去
            if (
              this.$route.path != "/login" &&
              this.$route.path != "/reg" &&
              this.$route.path != "/reset_pwd" &&
              this.$route.path != "/forget_pwd" &&
              this.$route.path != "/upload"
            ) {
              this.auto_log_out_dlg = true;
            }
          }
        }, 1000);
      }
    },
    // 退出登陆
    log_out_btn() {
      exitLogin().then((res) => {
        if (res.data.code == 200) {
          this.auto_log_out_dlg = false;

          // localStorage.clear();
          // sessionStorage.clear();
          sessionStorage.removeItem("token");
          sessionStorage.removeItem("userid");
          sessionStorage.removeItem("fa_dlg");
          sessionStorage.removeItem("project_name");
          this.$router.push("/login");
        }
      });
    },
    // 保持登陆
    maintain_login() {
      this.auto_log_out_dlg = false;
      this.time_out();
    },
    open_time_60() {
      if (
        sessionStorage.getItem("token") &&
        sessionStorage.getItem("userid") &&
        sessionStorage.getItem("username")
      ) {
        this.auto_timer = setInterval(() => {
          this.auto_Num--;
          if (this.auto_Num <= 0) {
            clearInterval(this.auto_timer);
            if (
              this.$route.path != "/login" &&
              this.$route.path != "/reg" &&
              this.$route.path != "/reset_pwd" &&
              this.$route.path != "/forget_pwd" &&
              this.$route.path != "/upload"
            ) {
              this.auto_log_out_dlg = false;
              this.log_out_btn();
            }
          }
        }, 1000);
      }
    },
    close_time_60() {
      clearInterval(this.auto_timer);
    },
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
@import "./assets/font/font_style.css";
#app {
  font-family: "font_style";
}
* {
  font-family: "font_style", "Helvetica Neue", Helvetica, "PingFang SC",
    "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

a {
  text-decoration: none;
}
ui,
li {
  list-style: none;
}

/* element ui dlg 弹框 上下左右居中 */
.el-dialog {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin: 0 !important;
  border-radius: 16px !important;
}
.el-dialog__headerbtn {
  left: 20px;
  font-size: 25px !important;
}
.el-dialog__title {
  margin-left: 50px;
}
.el-loading-mask {
  z-index: 999999;
}

.el-alert--success.is-light {
  color: #12ba9c !important;
}
.el-alert__title {
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 20px;
  color: #266856;
}
.el-loading-mask {
  z-index: 999999 !important;
}

/* 下拉框 换成三角图表 */
.el-icon-arrow-up:before {
  content: "" !important;
}
.el-select .el-input .el-select__caret {
  /* color: #314869 !important;
  font-size: 16px !important; */
}

/* pc 成功的右侧提示框 */
.succ_notify {
  background-color: #def8f1 !important;
  border-radius: 4px;
}
.succ_notify .el-icon-success {
  color: rgba(48, 211, 167, 1);
}
.succ_notify .el-notification__content {
  margin: 2px 0 0;
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 20px;
  color: #266856;
}
.succ_notify .el-notification__content {
  text-align: left !important;
}
/* ----over---- */

/* pc 失败的右侧提示框 */
.err_notify .el-notification__content {
  margin: 2px 0 0;
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 20px;
}
.err_notify .el-notification__content {
  text-align: left !important;
}
/* ----over---- */

/* element ui 下拉框 样式修改 */
.el-select-dropdown {
  background-color: #223c58 !important;
  border-radius: 8px !important;
  border-color: #223c58 !important;
}
.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background: #314b69 !important;
  border-radius: 4px !important;
  margin: 0 10px !important;
  padding-left: 10px !important;
}
.el-select-dropdown__item {
  color: #fff !important;
}
.el-select-dropdown__item.selected {
  color: #409eff !important;
  margin: 0 10px !important;
  padding-left: 10px !important;
}
.el-select-dropdown .popper__arrow {
  display: none !important;
}
/* ---over--- */

/* element ui 日历 */
.el-picker-panel {
  background-color: #223c58 !important;
  border-radius: 8px !important;
  border-color: #223c58 !important;
  color: #fff !important;
}
.el-date-table td.next-month,
.el-date-table td.prev-month {
  color: rgba(255, 255, 255, 0.2) !important;
}
.el-date-table th,
.el-picker-panel__icon-btn,
.el-date-picker__header-label {
  color: #fff !important;
}
.el-picker-panel .popper__arrow {
  display: none !important;
}
.el-date-table th {
  border-bottom: solid 1px rgba(49, 75, 105, 1) !important;
}
.el-picker-panel .el-date-table {
  font-style: normal !important;
  font-weight: normal !important;
  font-size: 15px !important;
}
/* 日历 英文 换位置 */
.zdy_picker_en
  > .el-picker-panel__body-wrapper
  > .el-picker-panel__body
  > .el-date-picker__header
  > span:nth-child(3) {
  /* background: red !important; */
  margin-left: 23px !important;
}
.zdy_picker_en
  > .el-picker-panel__body-wrapper
  > .el-picker-panel__body
  > .el-date-picker__header
  > span:nth-child(4) {
  /* background: yellow !important; */
  margin-left: -133px !important;
}
/* ----over---- */
</style>

<style>
/* 退出 弹框 */
.auto_log_out_dlg_bgc {
  background: #041e35 !important;
  color: #fff;
  border-radius: 16px !important;
}
.auto_log_out_dlg_bgc .el-dialog__header {
  padding: 0 !important;
}
/* 退出弹框 */
.log_out1 img {
  width: 40px;
  display: block;
  margin: auto;
}
.log_out2 {
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #ffffff;
  margin-top: 16px;
  text-align: center;
  word-break: break-word;
  word-wrap: break-word;
}
.log_out3 {
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 22px;
  text-align: center;
  color: #ffffff;
  opacity: 0.8;
  margin-top: 8px;
  text-align: center;
  word-break: break-word;
  word-wrap: break-word;
}
.u_r_icon {
  margin-left: 10px;
  margin-top: -30px;
  cursor: pointer;
  vertical-align: middle;
}

.li_log_out {
  margin-top: 15px;
}
.app_sidebar_btn {
  display: none;
}

.auto_log_out_dlg_bgc .cancel_btn,
.auto_log_out_dlg_bgc .cancel_btn:hover {
  color: #f1c788;
  border-color: #f1c788;
  background: transparent;
  min-width: 149px;
}
.auto_log_out_dlg_bgc .confirm_btn,
.auto_log_out_dlg_bgc .confirm_btn:hover {
  /* width: 130px; */
  min-width: 149px;
  background: linear-gradient(90deg, #f1c788 0.42%, #e3a84e 100.42%);
  box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
  border-color: #f1c788;
  border-radius: 4px;
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  color: #04182a;
  margin-left: 20px !important;
  margin-bottom: 15px;
}

/* --over-- */
</style>

<style>
/* 表格 */
.el-table {
  margin-top: 20px !important;
  background: #314b69 !important;
  border-radius: 16px !important;
  color: #fff !important;
}
.el-table::before {
  height: 0 !important;
}
.el-table thead {
  color: rgba(255, 255, 255, 0.6) !important;
  font-style: normal !important;
  font-weight: 400 !important;
  font-size: 15px !important;
}

.el-table tr,
.el-table th.el-table__cell {
  background-color: transparent !important;
}
.el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
  background: none !important;
}
.el-table--striped .el-table__body tr.el-table__row--striped td.el-table__cell {
  background: rgba(57, 82, 111, 1) !important;
}
.el-table td.el-table__cell {
  border-bottom: none !important;
}
.el-table thead tr .el-table__cell {
  border-bottom: 1.5px solid #041e35 !important;
}
.el-table tr th:first-child,
.el-table__body tr td:first-child {
  padding-left: 20px !important;
}
.el-table tr th:last-child,
.el-table__body tr td:last-child {
  padding-left: 20px !important;
}

.el-table .cell {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* ------ */
/* 分页器 */
.el-pagination {
  text-align: right !important;
  margin-top: 28px !important;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #deb981 !important;
  color: #041e35 !important;
}
.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  margin: 0 6px !important;
  border: 1px solid #314b69 !important;
  border-radius: 8px !important;
  width: 36px !important;
  height: 36px !important;
  line-height: 36px !important;
  text-align: center !important;
  color: rgba(255, 255, 255, 0.8) !important;
  background: transparent !important;
}
/* .el-pagination.is-background .el-pager li:not(.disabled):hover{
  color: red;
} */
/* ------ */
</style>

<style>
.dlg {
  background: rgb(4, 23, 40) !important;
  color: #fff;
}
.dlg >>> .el-dialog__title {
  color: #fff;
}
.dlg .el-dialog__headerbtn {
  text-align: left;
  /* display: inline-block; */
  left: 20px !important;
  top: 18px !important;
  width: 50px;
}
.dlg >>> .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}
.dlg >>> .el-dialog__body {
  padding: 9px 0 30px 0;
}
.element_input .el-input__inner {
  background: #223c58;
  border-color: #223c58;
  color: #fff;
}

.dlg_body {
  background: #041e35;
  color: #fff;
}
.d_body {
  box-sizing: border-box;
  padding: 40px 0;
  max-width: 420px;
  margin: auto;
}
.dlg_u_box {
  display: flex;
  align-items: center;
}
.dlg_u1 {
  width: 100px;
  height: 100px;
  border: 2px solid #deb981;
  border-radius: 50%;
}

.dlg_u3 {
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 18px;
  color: #ffffff;
  margin-left: 40px;
}
.dlg_form {
  margin-top: 25px;
}
.dlg_form2 {
  margin-top: 0;
  word-break: break-word;
}
.dlg_form2 .el-form-item:last-child {
  margin-bottom: 0;
}
.dlg_form .el-form-item__label {
  line-height: inherit;
  color: rgba(255, 255, 255, 0.6);
  padding: 0 !important;
  margin-bottom: 8px;
}
.dlg .cancel_btn,
.dlg .cancel_btn:hover,
.dlg .cancel_btn:focus,
.dlg .cancel_btn:active {
  color: #f1c788;
  border-color: #f1c788;
  background: transparent;

  line-height: 37px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.dlg .confirm_btn,
.dlg .confirm_btn:hover,
.dlg .confirm_btn:focus,
.dlg .confirm_btn:active {
  min-width: 86px;
  background: linear-gradient(90deg, #f1c788 0.42%, #e3a84e 100.42%);
  box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
  border-radius: 4px;
  border-color: #f1c788;
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  text-align: center;
  color: #04182a;
  /* margin-bottom: 15px; */
  margin-left: 20px !important;
}
.element_input .el-select {
  width: 100%;
}
</style>

<style>
.log_out_dlg_bgc .cancel_btn,
.log_out_dlg_bgc .cancel_btn:hover,
.log_out_dlg_bgc .cancel_btn:focus,
.log_out_dlg_bgc .cancel_btn:active {
  color: #f1c788;
  border-color: #f1c788;
  background: transparent;
}
.log_out_dlg_bgc .confirm_btn,
.log_out_dlg_bgc .confirm_btn:hover,
.log_out_dlg_bgc .confirm_btn:focus,
.log_out_dlg_bgc .confirm_btn:active {
  background: #ff4646;
  border-color: #ff4646;
  border-radius: 4px;
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  color: #ffffff;
  margin-bottom: 15px;
  margin-left: 20px !important;
}
</style>

<style>
.zdy_form_style .el-form-item {
  display: inline-block;
  width: 100%;
  margin-right: 20px;
}
.zdy_form_style .el-date-editor.el-input,
.zdy_form_style .el-select {
  width: 100%;
}
.zdy_form_style .el-form-item:last-child {
  margin-right: 0;
}
.zdy_form_style .el-form-item__label {
  padding: 0 !important;
  line-height: inherit;
  margin-bottom: 8px;
  color: rgba(255, 255, 255, 0.6);
}
.zdy_form_style .el-input__inner {
  background: #223c58;
  border: none;
  border-radius: 8px;
  color: #fff;
}
.zdy_form_style .el-input.is-disabled .el-input__inner {
  background-color: #223c58 !important;
}
</style>

<style>
.log_out_dlg_bgc .confirm_btn2,
.log_out_dlg_bgc .confirm_btn2:hover,
.log_out_dlg_bgc .confirm_btn2:focus,
.log_out_dlg_bgc .confirm_btn2:active {
  /* width: 130px; */
  min-width: 120px;
  background: linear-gradient(90deg, #f1c788 0.42%, #e3a84e 100.42%);
  box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
  border-color: #f1c788;
  border-radius: 4px;
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  color: #04182a;
  /* margin-left: 20px; */
  margin-bottom: 15px;
}
.log_out_dlg_bgc .padding1 {
  padding: 0 30px;
}
.log_out_dlg_bgc .padding2 {
  padding: 0 27px;
}
</style>

<style>
@media screen and (max-height: 1290px) {
  .dlg_height {
    left: 50%;
    top: 0;
    transform: translate(-50%, 0);
  }
}
</style>

<style>
.home_pop {
  background: #03101c !important;
  box-shadow: 0px 4px 8px rgba(3, 13, 22, 0.2) !important;
  border-radius: 12px !important;
  border: none !important;
  box-sizing: border-box !important;
  padding: 16px !important;
  word-break: break-word !important;
  word-wrap: break-word !important;
  text-align: left !important;
}
.home_pop .home_pop_body {
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  color: rgba(255, 255, 255, 0.6);
}
/* 下方是去除三角箭头的代码 */
.home_pop .popper__arrow::after {
  border-top-color: #03101c !important;
}
.home_pop .popper__arrow {
  border-top-color: #03101c !important;
}
</style>

<style>
/* add_dlg */
.add_dlg .el-dialog__body {
  padding-bottom: 0 !important;
}
.add_dlg .el-dialog__footer {
  padding: 28px;
}
.add_dlg .confirm_btn,
.add_dlg .confirm_btn:hover,
.add_dlg .confirm_btn:focus,
.add_dlg .confirm_btn:active {
  margin-bottom: 0;
}
</style>

<style>
/* zdy_tab_header */
.zdy_tab_header .el-table th.el-table__cell > .cell {
  line-height: inherit;
}
.zdy_tab_header .el-table thead tr .el-table__cell {
  padding: 10px 0;
}
.zdy_tab_header .el-table td.el-table__cell {
  padding: 18px 0;
}
.el-table {
  padding-bottom: 21px;
}
</style>

<style>
.time_box .el-date-table td.in-range div,
.time_box .el-date-table td.in-range div:hover,
.time_box .el-date-table.is-week-mode .el-date-table__row.current div,
.time_box .el-date-table.is-week-mode .el-date-table__row:hover div {
  background-color: #9cc8f5;
}
.zdy_form .el-range-input {
  background: #223c58;
  border: none;
  border-radius: 8px;
  color: #fff !important;
}
.zdy_form .el-range-separator {
  color: #fff !important;
}
.zdy_form .riqi_box {
  width: auto !important;
}
.zdy_form .el-input__inner::placeholder {
  /* color: #fff; */
}
</style>

<style>
/* element ui 日期图标 挪到右边 */
.el-date-editor .el-range__icon {
  position: absolute;
  right: 10px;
  top: 2px;
  background: url("./assets/img/riqi_icon.png") no-repeat;
  background-size: 14px 15px;
  background-position: 8px 10px;
}
.el-icon-date:before {
  content: "" !important;
}
</style>

<style>
/* 边框颜色渐变 */
.border_set_color {
  border: 1.5px solid transparent !important;
  border-radius: 4px !important;
  background-clip: padding-box, border-box !important;
  background-origin: padding-box, border-box !important;
  background-image: linear-gradient(to right, #314b69, #314b69),
    linear-gradient(90deg, #f1c788, #dda34c) !important;
}
.border_set_color2 {
  line-height: 37px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;

  border: 1.5px solid transparent !important;
  border-radius: 4px !important;
  background-clip: padding-box, border-box !important;
  background-origin: padding-box, border-box !important;
  background-image: linear-gradient(to right, #041e35, #041e35),
    linear-gradient(90deg, #f1c788, #e2a74d) !important;
}
.border_set_color3 {
  border: 1.5px solid transparent !important;
  border-radius: 4px !important;
  background-clip: padding-box, border-box !important;
  background-origin: padding-box, border-box !important;
  background-image: linear-gradient(to right, #223c58, #223c58),
    linear-gradient(90deg, #f1c788, #dda34c) !important;
}
.border_set_color4 {
  line-height: 37px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;

  border: 1.5px solid transparent !important;
  border-radius: 4px !important;
  background-clip: padding-box, border-box !important;
  background-origin: padding-box, border-box !important;
  background-image: linear-gradient(to right, #041e35, #041e35),
    linear-gradient(90deg, rgb(18, 186, 156), rgb(18, 186, 156)) !important;
}
</style>

<style>
/* 黄色警报框 */
.alert_style {
  min-height: 64px !important;
  background: #e8dac8 !important;
  border-radius: 4px !important;
}
.alert_style .el-alert__icon {
  color: #b28247 !important;
  font-size: 20px !important;
  width: 40px !important;
}
.alert_text {
  font-style: normal !important;
  font-weight: 600 !important;
  font-size: 15px !important;
  line-height: 20px !important;
  color: #b28247 !important;
  text-align: left !important;
  word-break: break-word !important;
  word-wrap: break-word !important;
}
.alert_num {
  font-weight: 700 !important;
  color: #314b69 !important;
}
</style>

<style>
/* 手机端 */
@media screen and (max-width: 850px) {
  .el-dialog {
    width: 100% !important;
  }
  .el-dialog__footer {
    text-align: center !important;
  }
  /* 日历控件 手机端样式 */
  .el-date-range-picker .el-picker-panel__body {
    min-width: 100%;
    width: 100%;
    max-width: 100%;
    display: flex;
    flex-direction: column;
  }
  .el-popper[x-placement^="bottom"] {
    margin-top: 12px;
    /* left: 10% !important; */
    /* width: 80%; */
  }
  .el-date-editor--daterange.el-input,
  .el-date-editor--daterange.el-input__inner,
  .el-date-editor--timerange.el-input,
  .el-date-editor--timerange.el-input__inner {
    width: 253px !important;
  }
  .el-picker-panel__body-wrapper,
  .el-date-range-picker {
    width: 329px !important;
  }
  .time_box .el-picker-panel__content {
    width: 100% !important;
  }
  .el-date-range-picker__content.is-left {
    border: none !important;
  }
  .time_box .el-picker-panel__body {
    min-width: 340px !important;
    max-width: 340px !important;
    /* background: pink !important; */
  }

  /* ------- */

  /* 下载表格按钮 */
  .t_h2_box {
    flex-direction: column;
    align-items: start !important;
  }
  .export_btn,
  .export_btn:hover,
  .export_btn:active,
  .export_btn:focus {
    margin-top: 10px !important;
  }

  /* 左侧无权限 提示 */
  .sidebar_pop_box {
    margin-left: 18px !important;
    width: 367px !important;
  }
  .sidebar_pop_box .pop_body {
    width: 315px;
    flex-direction: column;
  }

  /* -------- */

  /* 头部标题 展示 */
  .top_tit {
    text-overflow: ellipsis;
    max-width: 165px !important;
  }
  /* 4步上传步骤 */
  .kyc_step_box {
    width: 90% !important;
    margin-bottom: 20px;
  }
  .one_box {
    height: auto !important;
  }
  /* ------ */
  /* 日语 登陆注册 头部 */
  .tit_top_jp {
    text-align: center;
    margin-right: auto;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    box-sizing: border-box;
    padding-right: 55px;
  }
  .tit_top_jp .reg_btn {
    margin-top: 10px;
    width: max-content;
    line-height: initial;
  }
  /* ------ */

  /* 详情 id 省略号 */
  .th_tit4 {
    width: 122px;
    overflow: hidden;
    word-wrap: break-word;
  }

  /* 详情 表格 */
  .list_table > div {
    display: inline-flex !important;
    overflow-x: auto;
  }
  .list_table div .td4 {
    width: auto !important;
    display: flex !important;
  }
  .edit_btn {
    margin-right: 15px !important;
  }
  .d_body {
    padding: 40px 20px !important;
  }
  /* ------ */

  /* 提币三个步骤 */
  .div1 {
    font-size: 12px !important;
  }
  .s_img1 {
    width: 30px !important;
  }
  .s_img2 {
    width: 70px !important;
    right: -86px !important;
  }
  .sc_ntb {
    min-width: 280px !important;
  }
  .zdy_form_style .el-form-item__label {
    height: 38px !important;
  }
  /* ------ */
  .list_table > div > div {
    min-width: 150px !important;
  }
}
</style>
